import React from "react";
import ButtonLoader from "../atoms/buttonLoader";
import Button from "../atoms/button";

const ButtonWithLoading = (props) => {
  return (
    <Button
      disabled={props.disabled}
      onClick={props.onClick}
      style={props.style}
    >
      {props.isLoading ? (
        <ButtonLoader loaderSize={props.loaderSize} />
      ) : (
        props.children
      )}
    </Button>
  );
};

export default ButtonWithLoading;
